import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Constants } from '../helpers';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DescriptionOfWork } from '../interfaces/description-of-work';

/**
 * Service for managing the scope of work descriptions.
 * --
 * Future changes to inclusions/exclusions may fall under this service
 */
@Injectable()
export class ScopeService {
	constructor(private http: HttpClient) {
	}

	/**
	 * Adds a new description of work for a company
	 * @param data
	 */
	public addScopeTemplate(data: { title: string, message: string, company: string, type: string }) : Observable<DescriptionOfWork> {
		return this.http.post<DescriptionOfWork>(`${Constants.BASE_API_URL}/scope/scope-template`, data);
	}

	public getScopeTemplates(data: { company: string, type: string }): Observable<DescriptionOfWork[]> {
		return this.http
			.get<{ status: boolean; descriptions: DescriptionOfWork[]; message: string }>(
				`${Constants.BASE_API_URL}/scope/scope-templates`,
				{ params: data as any }
			)
			.pipe(map(res => res.descriptions ?? []));
	}

	public updateScopeTemplate(id: string, data: { title: string, message: string }): Observable<DescriptionOfWork> {
		return this.http.put<DescriptionOfWork>(`${Constants.BASE_API_URL}/scope/scope-template/${id}`, data);
	}

	public deleteScopeTemplate(id: string): Observable<void> {
		return this.http.delete<void>(`${Constants.BASE_API_URL}/scope/scope-template/${id}`);
	}
}